export const checkEnvTypeFromAzure = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URI
    const splitBaseURL = baseURL.split('/')

    const baseName = splitBaseURL.at(2)

    const regEx = /PRD/i
    // const regEx = /DEV/i

    // console.log("splitBaseURL", baseName.search(regEx))

    let isProdEnv = false;

    if (baseName.search(regEx) !== -1) {
        isProdEnv = true
    } else {
        isProdEnv = false
    }

    return {
        isProdEnv
    }
}